import { Divider } from '../../../Divider'
import { Skeleton } from '../../../Skeleton'

import * as styles from './ProfileContactsWidgetSkeleton.module.css'

function ProfileContactsWidgetSkeleton() {
  return (
    <div className={styles.container}>
      <Skeleton className={styles.header} />
      <Divider className={styles.divider} />

      {Array.from({ length: 3 }).map((_, index) => (
        <div className={styles.item} key={index}>
          <Skeleton className={styles.rowTop} />
          <Skeleton className={styles.rowBottom} />
        </div>
      ))}

      <Skeleton className={styles.footer} />
    </div>
  )
}

export default ProfileContactsWidgetSkeleton
